import type { App, Plugin } from 'vue'
import Typewriter from './components/Typewriter/index.vue'
import Bubble from './components/Bubble/index.vue'
import BubbleList from './components/BubbleList/index.vue'
import Thinking from './components/Thinking/index.vue'
import FilesCard from './components/FilesCard/index.vue'
import Attachments from './components/Attachments/index.vue'
import Conversations from './components/Conversations/index.vue'
import Sender from './components/Sender/index.vue'

// Export components for direct import
export { default as Typewriter } from './components/Typewriter/index.vue'
export { default as Bubble } from './components/Bubble/index.vue'
export { default as BubbleList } from './components/BubbleList/index.vue'
export { default as Thinking } from './components/Thinking/index.vue'
export { default as FilesCard } from './components/FilesCard/index.vue'
export { default as Attachments } from './components/Attachments/index.vue'
export { default as Conversations } from './components/Conversations/index.vue'
export { default as Sender } from './components/Sender/index.vue'

// Export types
export type { BubbleProps } from './components/Bubble/types'
export type { ThinkingStatus } from './components/Thinking/types'
export type { FilesCardProps, FilesType } from './components/FilesCard/types'
export type { ConversationItem, ConversationMenuCommand } from './components/Conversations/types'
export type { BubbleListInstance, BubbleListItemProps, BubbleListScrollState } from './components/BubbleList/types'

const ElementPlusY: Plugin = {
  install(app: App) {
    app.component('Typewriter', Typewriter)
    app.component('Bubble', Bubble)
    app.component('BubbleList', BubbleList)
    app.component('Thinking', Thinking)
    app.component('FilesCard', FilesCard)
    app.component('Attachments', Attachments)
    app.component('Conversations', Conversations)
    app.component('Sender', Sender)
  },
}

export default ElementPlusY
